import "@babel/polyfill";
import * as React from "react";
import ReactDOM from "react-dom";
import Main from "./main";

ReactDOM.render(<Main />, window.document.getElementById("app"));
